import './GradientColor.scss';

type GradientColorProps = {
    className?: string,
    label?: string,
    value: number,
    disabled?: boolean,
    onChange: (value: number) => void,
};

function GradientColor(props: GradientColorProps) {

    return (
        <div className={`gradientcolor-container ${props.className ?? ''}`}>
            {props.label && (
                <span className="gradientcolor-label">{props.label}</span>
            )}
            <div className="gradientcolor-list">
                {new Array(15).fill(0).map((_, index: number) => (
                    <div key={index} className={`gradientcolor-item ${index === props.value ? 'active': ''}`} onClick={() => props.onChange(index)}>
                        <div className={`gradientcolor-item-circle gradient-color-${index}`}></div>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default GradientColor;
